import React, { useState } from "react";
import { Link } from "react-router-dom";
import css from "./Nav.module.css";
import { routes } from "../App/index";
import AutoSamplete from "../AutoSamplete";
import LoggedUser from "../LoggedUser";
import Logout from "../Logout";
import ItemDisplay from "../AutoSamplete/ItemDisplay";

function Nav() {
  const [contract, setContract] = useState(null);
  return (
    <div>
      <nav>
        {/* <h2 className={css.cello}> Navigation </h2> */}
        <img
          className={css.icons}
          src="https://www.birminghamcivicsociety.org.uk/wp-content/uploads/2017/04/West-Midlands-Combined-Authority.gif"
        />
        <ul className={css.navlinks}>
          <Link to={routes.dash}>
            <li> Dashboard </li>
          </Link>
          <Link to={routes.provider}>
            <li> Providers </li>
          </Link>
          <Link to={routes.contracts}>
            <li> Contracts </li>
          </Link>
          <AutoSamplete contract={contract} setContract={setContract} />
        </ul>
      </nav>
      <div className={css.ItemDisplayMod}>
        {contract ? <ItemDisplay {...contract} /> : null}
      </div>
      <div class={css.fixed}>
        <div className={css.container}>
          <p>Copyright &copy; 2020 WestMidlands Combined Authority</p>
        </div>
        <LoggedUser />
        <Logout />
      </div>
    </div>
  );
}
export default Nav;
